import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import PaginationTable from '../../../../shared/PaginationTable';
import { useBreakpoints } from '../../../../shared/globalStyling/screenSizes';
import { pagination } from '../../../../ux/Tasks/configs/designTokens';

// ─── Card view (tablet / mobile) ────────────────────────────────────────
const DealIdCardList = ({ data, selectedKeys, onSelect, onEdit }) => (
  <div className="deal-card-list">
    {data.map((record) => {
      const isSelected = selectedKeys.includes(record.id);
      return (
        <div
          key={record.id}
          className={`deal-card${isSelected ? ' deal-card--selected' : ''}`}
          onClick={() => onSelect(record.id)}
        >
          <div className="deal-card__header">
            <span className="deal-card__name">{record.name}</span>
            <button
              type="button"
              className="deal-card__edit-btn"
              onClick={(e) => {
                e.stopPropagation();
                onEdit(record);
              }}
            >
              <EditOutlined />
            </button>
          </div>
          <div className="deal-card__id">{record.dealId}</div>
        </div>
      );
    })}
  </div>
);

export const TargetingDealIdsTable = ({
  dealIds,
  setSelectedDealIdKeys,
  setSelectedDealId,
  setIsFormOpen,
  searchText,
}) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(pagination.defaultPageSize);
  const [selectedCardKeys, setSelectedCardKeys] = useState([]);

  const { isTablet } = useBreakpoints();

  const handleUpdate = (record) => {
    setSelectedDealId(record);
    setIsFormOpen(true);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      ellipsis: true,
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
      render: (name) => (
        <Tooltip title={name}>
          <span className="targeting-deal__name-text">{name}</span>
        </Tooltip>
      ),
    },
    {
      title: 'Deal ID',
      dataIndex: 'dealId',
      key: 'dealId',
      width: 200,
      ellipsis: true,
      render: (dealId) => (
        <span className="targeting-deal__mono">{dealId}</span>
      ),
    },
    {
      title: '',
      key: 'actions',
      width: 60,
      align: 'right',
      render: (_, record) => (
        <div className="targeting-deal__actions">
          <Tooltip title="Edit">
            <button
              className="targeting-deal__action-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleUpdate(record);
              }}
            >
              <EditOutlined />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const filteredData = dealIds
    ? dealIds.filter((d) =>
        searchText
          ? (d.name || '').toLowerCase().includes(searchText.toLowerCase()) ||
            (d.dealId || '').toLowerCase().includes(searchText.toLowerCase())
          : true
      )
    : [];

  const handleCardSelect = (dealId) => {
    setSelectedCardKeys((prev) => {
      const next = prev.includes(dealId)
        ? prev.filter((id) => id !== dealId)
        : [...prev, dealId];
      setSelectedDealIdKeys(next);
      return next;
    });
  };

  if (!filteredData.length) return null;

  return isTablet ? (
    <DealIdCardList
      data={filteredData}
      selectedKeys={selectedCardKeys}
      onSelect={handleCardSelect}
      onEdit={handleUpdate}
    />
  ) : (
    <div className="targeting-deal__table">
      <PaginationTable
        columns={columns}
        data={filteredData}
        scroll={{ x: 500 }}
        bordered={false}
        paginationSize={'default'}
        size={'small'}
        current={page}
        pageSize={pageSize}
        total={filteredData.length}
        rowSelection={{
          type: 'checkbox',
          onChange: (selectedRowKeys) => {
            setSelectedDealIdKeys(selectedRowKeys);
          },
        }}
        onChange={(paginationObject) => {
          setPageSize(paginationObject.pageSize);
          setPage(paginationObject.current);
        }}
        rowKey="id"
      />
    </div>
  );
};
